import React from 'react';
import PropTypes from 'prop-types';
import LabeledItem from '../../nucleus/labeled-item/labeled-item';

/**
 * ConnectorIdDisplay
 * Renders a read-only Connector ID field when a valid connector_id is present on the deal.
 * Hidden entirely for non-CPro (no connector_id) deals.
 */
const ConnectorIdDisplay = ({ deal, label }) => {
  if (!deal || deal.connector_id === undefined || deal.connector_id === null || `${deal.connector_id}`.trim() === '') {
    return null;
  }

  return (
    <LabeledItem
      label={label}
      item={deal.connector_id}
      // semantic hint: read-only data
      data-e2e="connector-id-display"
    />
  );
};

ConnectorIdDisplay.propTypes = {
  deal: PropTypes.shape({
    connector_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  label: PropTypes.string,
};

ConnectorIdDisplay.defaultProps = {
  deal: undefined,
  label: 'Connector ID',
};

export default ConnectorIdDisplay;
